import { DropZoneWrapper } from "../../../Common/DropZoneWrapper";
import { EntityModalForm } from "./EntityModalForm";
import { CRUDFabric } from "../../CRUDFabric";
import { SaveButton } from "../../../components/SaveButton";
import Compressor from "compressorjs";

export const HasAttachments = {

    compressFormats: ['image/jpeg','image/jpg','image/png','image/gif'],
    maxScaleImagePx:1000,
    isPrepareFiles:false,
    prepareFiles:null,
    QueryData: null,
    isHightQuality: false,
    SuccessCallback: () => {},

    attachmentUrl() {
        console.log(this.id);
        return this.id ? `${this.urlRoot}/${this.id}/add-attachment` : 'restrict';
    },

    async attachFiles(files, callback=()=>{}, addQueryData={}) {

        if (files.length == 0) {
            return;
        }

        const url = this.attachmentUrl();
        const SaveBtn = new SaveButton('#dropzone-modal');
        if ((url == 'restrict' && !this.isPrepareFiles)) {
            callback();
            return;
        };
        SaveBtn.startLoading('Uploading');
        let flag = true;
        $('.dropzone-error-message-container').text('');
        let file_type = "doc"; //указание типа стоит переделать
        let data = await this.prepareFilesData(files, file_type, this.isPrepareFiles)
        if (this.isPrepareFiles){
            SaveBtn.stopLoading(true,'Upload').then(() => {
                SaveBtn.showSuccess()
                .then(() => setTimeout(() => {
                    if(this.isPrepareFiles){
                        document.dispatchEvent(new CustomEvent('prepare_files', { detail: { files } }))
                    }
                    this.dropzone.container.modal('hide')
                    delete this.dropzone;
                }, 1000));
            })
            callback()
            return
        }
        for(let key in addQueryData){
            data.append(key,addQueryData[key])
        }
        if (this.QueryData) {
            for(let key in this.QueryData){
                data.append(key,this.QueryData[key])
            }
        }

        $.ajax({
            url,
            method: "POST",
            processData: false,
            contentType: false,
            data,
            success: (response) => {
                SaveBtn.stopLoading(true,'Upload').then(() => {
                    SaveBtn.showSuccess()
                    .then(() => setTimeout(() => {
                        this.SuccessCallback(response);
                        callback(response)
                        this.dropzone.container.modal('hide')
                        delete this.dropzone;
                    }, 1000));
                })
            },
            error: (response) => {
                SaveBtn.stopLoading(false,'Upload').then(()=>{
                    SaveBtn.showError()
                })
                let errors = {};
                if (response.status == 413) {
                    errors['filesize'] = ['File is too large. Size limit is 5mb.'];
                } else {
                    errors = response.responseJSON.errors;
                }

                if (errors) {
                    $('.dropzone-error-message-container').text('Error: ');
                    Object.values(errors)[0].forEach(element => {
                        $('.dropzone-error-message-container').append('<br>'+element);
                    });
                    $('.dropzone-error-message-container').removeClass('d-none');
                }
                flag = false;
            }
        });
        return flag;
    },

    deleteAttachment(fileId, entityId, fileBox, cb=()=>{}){
        let url = entityId ? `${this.urlRoot}/${entityId}/delete-attachment` : 'restrict';
        if(url == 'restrict' || fileId == null){
            cb()
            return
        }
        let data = new FormData()
        data.append('fileId', fileId)
        $.ajax({
            url,
            method: "POST",
            processData: false,
            contentType: false,
            data,
            success: (response) => {
                fileBox.remove();
                $('.dropzone-error-message-container').addClass('d-none');
                cb(response);
            },
            error: (response) => {
                let errors = response.responseJSON.errors;
                if (errors) {
                    $('.dropzone-error-message-container').text('Error: ');
                    Object.values(errors)[0].forEach(element => {
                        $('.dropzone-error-message-container').append('<br>'+element);
                    });
                    $('.dropzone-error-message-container').removeClass('d-none');
                }
            }
        });
    },

    setAttachmentCallbackDelete(callback=()=>{}){
        $('body').off('click','.delete-file-btn').on('click','.delete-file-btn',(e)=>{
            let entityObj = this
            let parent = $(e.currentTarget).parents('[data-file-item]')[0]
            const entity = $(e.currentTarget).data('entity')
            const fileId = $(e.currentTarget).data('file-id')
            const entityId = $(e.currentTarget).data('entity-id')
            if(!fileId || !entityId ||!entity)
                return
            const Entity = CRUDFabric.getClass(entity)
            if(!(entityObj instanceof Entity)){
                entityObj = new Entity(entityId)
            }
            entityObj.deleteAttachment(fileId,entityId,parent)
            setTimeout(() => {
                callback();
            }, 200);
        })
    },

    setAttachmentCallbackPreview(){
        $('body').off('click','.preview-file-btn').on('click','.preview-file-btn',(ev)=>{
            $('#preview-modal #preview-image').attr('src', $(ev.currentTarget).data('src'))
            $('#preview-modal').modal('show');
        })
    },

    async prepareFilesData(files, file_type=null, isPrepare=false) {
        let data = new FormData()
        for(let i=0; i<files.length; i++){
            if(files[i]?.upload?.filename && files[i].name != files[i].upload.filename)
                files[i] = new File([files[i]], files[i].upload.filename ,{type: files[i].type})
        }
        let options = {};
        if (this.isHightQuality) {
            options = {
                'quality': 0.9,
                'convert_size':150000,
            };
        }
        files = await this.zipImages(files, options)
        for(let key in files){
            if (file_type !==null) {
                data.append('files[' + file_type + '][]', files[key]);
            }else{
                data.append('files[' + files[key].type + '][]', files[key]);
            }
        }
        if(isPrepare){
            if(this.prepareFiles instanceof FormData){
                for (const [key, file] of data.entries()) {
                    this.prepareFiles.append(key, file);
                }
            }else{
                this.prepareFiles = data
            }
        }
        return data;
    },

    async zipImages(files, options = {}){
        try{
            let quality = options.quality ?? 0.6;
            let size=options.convert_size ?? 100000;

            const promisses = []
            const images = files.filter(f=>this.compressFormats.includes(f.type))
            if(!images.length)
                return files
            for(let image of images){
                promisses.push(this.compressImage(image, size, quality))
            }
            let results = (await Promise.allSettled(promisses)).filter(r=>r!=false && r?.status=='fulfilled')
                                                                .map(r=>r.value)
            results = [...results, ...files.filter(f=>!this.compressFormats.includes(f.type))]
            return results
        }catch(err){
            console.error(err)
            return false
        }
    },

    compressImage(file, convert_size=100000, quality=0.6) {
        return new Promise(resolve => {
            new Compressor(file, {
                convertTypes: ['image/png'],
                convertSize: convert_size,
                quality: quality,
                maxWidth: this.maxScaleImagePx,
                maxHeight: this.maxScaleImagePx,
                success: (result) => {
                    let resultFile = new File([result], result.name, {type: result.type})
                    resultFile.upload = file.upload
                    resolve(resultFile);
                },
                err: (err)=>{
                    resolve(false)
                }
            });
        });
    },

    openDropZone(options={}, addQueryData={}, callback = () =>{}) {

        if (this.dropzone) delete this.dropzone;
        let local_options = {
            modal: {
                template: '#dropzone',
                selector: '#dropzone-modal',
                submit: {
                    element: '#submit-attachments',
                    event: 'click',
                    handler: (files, callback=()=>{}) => {
                        //console.log(callback);
                        this.attachFiles(files, callback, addQueryData);
                    }
                },
                remove_file: {
                    element: '.delete-file-button',
                    event: 'click',
                    handler: (files) => {
                        console.log(files);
                        if (files.length == 0) {
                            $('#submit-attachments').attr('disabled', 'disabled');
                        }
                    }
                }
            },
            successCallback: callback,
        };
        let complete_options = Object.assign(local_options, options);
        this.dropzone = DropZoneWrapper.init(complete_options, {
            url: this.attachmentUrl()
        });
        //window.dropzone = this.dropzone;

        return this.dropzone;
    },


    viewAttachments() {
        $.ajax({
            url: `${this.urlRoot}/${this.id}/view-attachments`,
            success: (response) => {
                EntityModalForm.pasteForm(response);

                const attachmentsModal = $(`#attachments-modal`);
                attachmentsModal.modal('show');

                $(document).off('added_file').on('added_file', (e) => {
                    const attachTemplate = document.querySelector('#attachment-row-template')
                    if(attachTemplate && e?.detail?.file){
                        const file = e.detail.file
                        const newPreview = attachTemplate.cloneNode(true)
                        newPreview.removeAttribute('id')
                        newPreview.classList.add('d-flex')
                        newPreview.classList.add('d-none')
                        newPreview.querySelector(`[data-file-type="${/^image\/.*/.test(file.type)? 'doc':'img'}"]`).remove()
                        const downloadLink = newPreview.querySelector('.attachment__link')
                        download.href = URL.createObjectURL(file)
                        download.download = file.upload.filename
                        if(/^image\/.*/.test(file.type)){
                            const previewLink = newPreview.querySelector('.preview-file-btn')
                            if(previewLink){
                                previewLink.setAttribute('data-src',URL.createObjectURL(file))
                                previewLink.classList.remove('d-none')
                            }
                        }
                        let newNameArr = file.upload.filename.split('.')
                        newNameArr[0]=newNameArr[0]+'_new'
                        newNameArr[0] = newNameArr[0].length > 20 ? '...'+newNameArr[0].slice(0,20) : newNameArr[0]
                        newPreview.querySelector('.filename').textContent = newNameArr.join('.')
                        attachmentsModal.find('#attachments-container').append(newPreview);
                    }
                });
            }
        });
    },

    scopeOpenDropZoneListener(addQueryData={}, callback = ()=>{}) {
        $('body')
            .off('click', '.upload-files')
            .on('click', '.upload-files', (e) => {
                let ftype = $(e.currentTarget).data('file_type')
                const id = $(e.currentTarget).data('id')
                const entity = $(e.currentTarget).data('entity')
                if(id && entity && (this?.entityClass != entity || this?.id != id)){
                    const entityClass = CRUDFabric.getClass(entity)
                    if(entityClass){
                        let objEntity = new entityClass(id)
                        if(objEntity?.openDropZone)
                            objEntity.openDropZone({accessFileType:ftype}, addQueryData, callback)
                    }
                }else{
                    this.openDropZone({accessFileType:ftype}, addQueryData, callback);
                }
            });
    },

    create(successCallback=this.callbackCloseModal, errorCallback=()=>{}, method='PUT') {
        const formId = `create-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const SaveBtn = new SaveButton();
        let addParams = {}
        if(data instanceof FormData){
            addParams={
                processData: false,
                contentType: false,
                cache: false,
            }
        }
        $.ajax({
            url: `${this.urlRoot}/create`,
            method: method,
            data: data,
            ...addParams,
            beforeSend: () => {
                SaveBtn.startLoading();
            },
            success: (response) => {
                this.id = response.id;
                if(this.dropzone) {
                    this.dropzone.updateConfig({url: this.attachmentUrl()});
                    this.dropzone.dispatchOwnerCreated();
                }
                SaveBtn.stopLoading(true).then(() => {
                    SaveBtn.showSuccess()
                    .then(()=>successCallback(response))
                    .then(result => {
                        if(result) setTimeout(() => window.location.reload(), 500)
                    });
                })
            },
            error: (response) => {
                SaveBtn.stopLoading().then( () => {
                    SaveBtn.showError().then(() => {
                        errorCallback(response)
                    })
                })
            }
        })
    }
}
